var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.75C4.54788 1.75 1.75 4.54788 1.75 8C1.75 11.4521 4.54788 14.25 8 14.25C11.4521 14.25 14.25 11.4521 14.25 8C14.25 4.54788 11.4521 1.75 8 1.75ZM0.25 8C0.25 3.71945 3.71945 0.25 8 0.25C12.2805 0.25 15.75 3.71945 15.75 8C15.75 12.2805 12.2805 15.75 8 15.75C3.71945 15.75 0.25 12.2805 0.25 8Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.197 6.13642C11.4899 6.42931 11.4899 6.90418 11.197 7.19708L7.86368 10.5304C7.71986 10.6742 7.52379 10.7535 7.32043 10.75C7.11706 10.7465 6.92384 10.6605 6.78506 10.5118L4.45172 8.01187C4.16909 7.70906 4.18545 7.23446 4.48826 6.95184C4.79107 6.66921 5.26566 6.68557 5.54829 6.98838L7.35194 8.92082L10.1363 6.13642C10.4292 5.84352 10.9041 5.84352 11.197 6.13642Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCircle);
export default __webpack_public_path__ + "static/media/icon-check-circle.cee5c2f7a6b97a6cd807f388a2e8941b.svg";
export { ForwardRef as ReactComponent };